import React, { useState } from "react";
import { Button, PdfGenerator } from "../../../../../components";
import generatePdf from "../../../../../components/PdfGenerator/generatePdf";
import Backdrop from "../../../../../components/Backgrounds/Backdrop";

import TimesheetHeader from "./Timesheet/TimesheetHeader";
import TimesheetContent from "./Timesheet/TimesheetContent";
import InvoiceFooter from "./Invoice/InvoiceFooter";
import TimesheetTableHeader from "./Timesheet/TimesheetTableHeader";
import TimesheetData from "./Timesheet/TimesheetData";
import TimesheetFooter from "./Timesheet/TimesheetFooter";
/////////////////
import logo from "../../../../../assets/images/headerLogo.svg";
import logoDark from "../../../../../assets/images/LogoDark.svg";

const TimesheetGenerator = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const data = {
    company: {
      name: "TekTree LLC",
      address: "1106 Drummond Plaza, DE 19711",
      contact: "+1 (123) 456-7890",
      email: "accounts@tektreeinc.com",
      website: "www.tektreeinc.com",
      companyLogo: logoDark,
      additionalInfo: `This Invoice has been Sold & Assigned to Tek Tree LLC Remit payment only to: P.O Box #799, Gloucester, VA - 23061, C/O Chesapeake Bank, Chesapeake Bank`,
    },
    client: {
      name: "intellix software, inc",
      address: "123 Main St, Anytown, USA",
      phone: "123-456-7890",
      email: "info@intellixsoftware.com",
    },
    employee: {
      id: "EMP-001",
      status: "Active",
      name: "Rohit Mishra",
      designation: "Developer",
      address: "465 Main St, Anytown, India",
      phone: "456-123-7890",
      email: "rohit@intellixsoftware.com",
    },
    timesheetPeriod: {
      from: "2025-11-01T11:09:00.000Z", // Saturday
      to: "2025-11-30T11:09:00.000Z", // Sunday
    },
    timesheetData: [],
  };

  // Helper to generate random work hours between two values
  const randomHours = (min, max) => {
    const hours = Math.floor(Math.random() * (max - min + 1)) + min;
    const minutes = Math.random() < 0.5 ? "00" : "30"; // half-hour increments
    return `${hours.toString().padStart(2, "0")}.${minutes}`;
  };

  // Parse dates
  const from = new Date(data.timesheetPeriod.from);
  const to = new Date(data.timesheetPeriod.to);

  // --- Align start to Monday ---
  const start = new Date(from);
  const startDay = start.getDay(); // 0 = Sunday
  const diffToMonday = startDay === 0 ? -6 : 1 - startDay;
  start.setDate(start.getDate() + diffToMonday);

  // --- Align end to Sunday ---
  const end = new Date(to);
  const endDay = end.getDay(); // 0 = Sunday
  const diffToSunday = endDay === 0 ? 0 : 7 - endDay;
  end.setDate(end.getDate() + diffToSunday);

  const timesheetData = [];

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const date = new Date(d);
    const isoDate = date.toISOString();
    const dayOfWeek = date.getDay();

    let standardTime = "";
    let totalBillableHours = "";
    let totalHours = "";

    // Only fill actual range with data
    if (date >= from && date <= to) {
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        // Weekdays
        const workHours = randomHours(7, 9);
        standardTime = "08.00";
        totalBillableHours = workHours;
        totalHours = workHours;
      } else {
        // Weekends
        standardTime = "00.00";
        totalBillableHours = "00.00";
        totalHours = "00.00";
      }
    } else {
      // Outside actual period → keep null/empty
      standardTime = null;
      totalBillableHours = null;
      totalHours = null;
    }

    timesheetData.push({
      date: isoDate,
      standardTime,
      totalBillableHours,
      totalHours,
    });
  }

  data.timesheetData = timesheetData;

  //console.log(data);

  const totalValue = data.timesheetData.reduce(
    (acc, item) => {
      const parseTime = (timeStr) => {
        if (!timeStr) return { hours: 0, minutes: 0 }; // ✅ handle null or ""
        const [h, m] = timeStr.split(".");
        return { hours: Number(h) || 0, minutes: Number(m) || 0 };
      };

      const addTime = (accKey, timeStr) => {
        const { hours, minutes } = parseTime(timeStr);
        accKey.hours += hours;
        accKey.minutes += minutes;

        // Convert minutes overflow to hours
        if (accKey.minutes >= 60) {
          accKey.hours += Math.floor(accKey.minutes / 60);
          accKey.minutes %= 60;
        }
      };

      addTime(acc.standardTime, item.standardTime);
      addTime(acc.totalBillableHours, item.totalBillableHours);
      addTime(acc.totalHours, item.totalHours);

      return acc;
    },
    {
      standardTime: { hours: 0, minutes: 0 },
      totalBillableHours: { hours: 0, minutes: 0 },
      totalHours: { hours: 0, minutes: 0 },
    }
  );

  // Convert to decimal total
  const toDecimal = ({ hours, minutes }) =>
    Number((hours + minutes / 60).toFixed(2));

  data.finalStandardTime = toDecimal(totalValue.standardTime).toFixed(2);
  data.finalTotalBillableHours = toDecimal(
    totalValue.totalBillableHours
  ).toFixed(2);
  data.finalTotalHours = toDecimal(totalValue.totalHours).toFixed(2);

  // console.log({
  //   finalStandardTime: data.finalStandardTime,
  //   finalTotalBillableHours: data.finalTotalBillableHours,
  //   finalTotalHours: data.finalTotalHours,
  // });

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await generatePdf({
        initialLayout: "landscape",
        items: data.timesheetData,
        // Render 7-day rows: pass the full items array and current index
        rowRenderer: (_, index) => TimesheetData(data.timesheetData, index),
        header: () => <TimesheetHeader data={data} />,
        headerTwo: () => <TimesheetHeader data={data} type="sub" />,
        contentTop: () => <TimesheetContent data={data} type="top" />,
        contentBottom: () => <TimesheetContent data={data} type="bottom" />,
        tableHeader: () => <TimesheetTableHeader />,
        footer: (page) => <TimesheetFooter data={data} {...page} />,
        footerTwo: (page) => (
          <TimesheetFooter data={data} type="sub" {...page} />
        ),
        // footerTwo: (page) => (
        //   <TimesheetFooter data={data} type="sub" {...page} />
        // ),
        backgroundLogo: logoDark,
        fileName: `Timesheet-001`,
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <div>
        <Backdrop isOpen={isDownloading}>
          <div className="w-16 h-16 border-[5px] border-gray-800 border-b-primary rounded-full animate-spin" />
        </Backdrop>
        <Button title={"Download PDF"} onClick={handleDownload} />
      </div>
      <div className="flex-1 w-full h-full overflow-auto">
        <PdfGenerator
          initialLayout="landscape"
          items={data.timesheetData}
          header={() => <TimesheetHeader data={data} />}
          headerTwo={(page = {}) => (
            <TimesheetHeader
              data={data}
              type="sub"
              currentPage={page.currentPage}
              totalPages={page.totalPages}
            />
          )}
          contentTop={() => <TimesheetContent data={data} type="top" />}
          contentBottom={() => <TimesheetContent data={data} type="bottom" />}
          tableHeader={() => <TimesheetTableHeader />}
          rowRenderer={(_, index) => TimesheetData(data.timesheetData, index)}
          footer={(page = {}) => (
            <TimesheetFooter
              data={data}
              currentPage={page.currentPage}
              totalPages={page.totalPages}
            />
          )}
          footerTwo={(page = {}) => (
            <TimesheetFooter
              data={data}
              type="sub"
              currentPage={page.currentPage}
              totalPages={page.totalPages}
            />
          )}
          backgroundLogo={logoDark}
          fileName={`Timesheet-001`}
        />
      </div>
    </div>
  );
};

export default TimesheetGenerator;
